
import React from 'react';
import moment from 'moment';
import { formatPercentNum, formatSmallValue, unitConversion } from '@/pages/dashboard/utils/utils';
import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import { contrastLine, getCardChart, xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';
import { yAxisFormat } from '@/pages/dashboard/components/Chart/_config/utils';
import { thousandthFormat } from '@/pages/home/utils/common';
import { useIntl } from 'umi';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

const MetricCardChartItem = (props: any) => {
  const { timeType, isPlatform = false, index, dataSource, isMoblie = false, isNightingale,filterVal,isContrastSDLW, isLeftCard: propsIsLeftCard } = props;

  const {
    type,
    decimal = 2,
    isLeftCard = false,
    name,
    metrics_name,
    xAxisData,
    series,
    formatRule,
  } = dataSource || {};

  const { formatMessage } = useIntl();
  const shouldUseLeftCardTooltip = (typeof propsIsLeftCard === 'boolean') ? propsIsLeftCard : isLeftCard;

  const formatterFunc = (param: string | any[]) => {
    const date = timeType === 'Month' ? moment(param[0]?.axisValue).format('YYYY-MM') : moment(param[0]?.axisValue).format('YYYY-MM-DD');
    let returnStr = `<div class=${'basic-formatter-box'}>
      <div class=${'basic-formatter-header'}>
      <p class='basic-formatter-one basic-formatter-title'>${date}</p>
      <p class='basic-formatter-two'>${name}</p></div>`;
    for (let i = 0;i < param.length;i++) {
      const paramValue = param[i].value;
      // TOFIX: 临时处理，产品说不要把负数改为正数
      const dauValue = formatRule ? dataFormat({ value: paramValue, formatRule}) : type === 'percent' ? `${paramValue < 0 ? '-' : ''}${formatPercentNum(paramValue, decimal, false)}` :
        metrics_name === 'arpu' ? formatSmallValue(paramValue, 'decimals', 2) :
          thousandthFormat(paramValue, type === 'int' ? 0 : decimal, true, '-');
      const name = param[i].seriesName;
      const radio = `<span style="display:inline-block;margin-right:4px;border-radius:8px;width:8px;height:8px;background-color:${param?.[i]?.color}"></span>`;
      returnStr += `<div class=${'basic-formatter-header'}>
        <p class=${'basic-formatter-one'}>${radio}&nbsp;${name}</p>
        <p class=${'basic-formatter-two'}>${dauValue}</p></div>`;
    }
    returnStr = `${returnStr}`;
    return returnStr;
  };
  // 夜莺实时用户卡片
  const formatterFuncNightingale = (raw: any | any[]) => {
    const paramsArr = Array.isArray(raw) ? raw : [raw];
    const paramMap = new Map(paramsArr.map(p => [p.seriesName, p]));
    const axisValue = paramsArr[0]?.axisValue ?? '';
    const date = moment(axisValue).format('YYYY-MM-DD HH:mm');
    const today = moment(filterVal?.singleDaily).format('YYYY-MM-DD');
    const yesterday = moment(today).subtract(1, 'days').format('YYYY-MM-DD');
    const contrast = moment(filterVal?.contrastDaily).format('YYYY-MM-DD');
    // 提取一行数据的 HTML
    const getItemHtml = (name: string, index: number) => {
      const p = paramMap.get(name);
      const val = p?.value;
      const color = ['#5086F3', '#69D19C', '#6E7794'][index] ?? '#ccc';
      const radio = `<span style="display:inline-block;margin-right:4px;border-radius:8px;width:8px;height:8px;background-color:${color}"></span>`;
      let formattedVal = '-';
      if (val !== undefined && val !== null) {
        if (type === 'percent') {
          formattedVal = `${val < 0 ? '-' : ''}${formatPercentNum(val, decimal, false)}`;
        } else {
          const precision = type === 'int' ? 0 : decimal;
          formattedVal = thousandthFormat(val, precision, true, '-');
        }
      }
      let labelDate = contrast;
      if (index === 0) labelDate = today;
      else if (index === 1) labelDate = yesterday;
      const contrastMark =
      (name === 'Same Day Last Week' || name === '上周同期') && isContrastSDLW
        ? `&nbsp;(${formatMessage({ id: 'contrast day' })})`
        : '';
      return `
      <div class="basic-formatter-header">
        <p class="basic-formatter-one">${radio}&nbsp;${name}&nbsp;${labelDate}${contrastMark}</p>
        <p class="basic-formatter-two">${formattedVal}</p>
      </div>
    `;
    };
    const contentHtml = series.map((s: { name: string; }, i: number) => getItemHtml(s.name, i)).join('');
    return `
    <div class="basic-formatter-box">
      <div class="basic-formatter-header">
        <p class="basic-formatter-one basic-formatter-title">${date}</p>
        <p class="basic-formatter-two"></p>
      </div>
      ${contentHtml}
    </div>
  `;
  };

  return <div className="overlay-card-content overlay-card-flex-right">
    <LineChart
      height={75}
      xAxisData={xAxisData || []}
      series={series || []}
      isShowLegend={false}
      formatterFunc={isNightingale ? formatterFuncNightingale : formatterFunc}
      setOtherConfigFunc={(opt) => {
        opt = getCardChart(opt, { timeType });
        if (isNightingale) {
          opt = contrastLine(opt, {
            formatter: (value: any) => {
              const val = value?.slice(11, 13)?.replace(/\b(0+)/gi, "");
              return value ? val === '' ? 0 : val : '';
            },
            xSplitNumber: 6
          });
        }
        opt = xAxisHighLight(opt, {
          lineStyle: {
            type: 'solid'
          },
          formatter: (params: any) => {
            const time = moment(params?.value).format('HH:mm');
            return isNightingale ? time : timeType === 'Month' ? params?.value?.slice(4, 6) : params?.value?.slice(-2);
          },
          symbolSize: 8,
          fontSize: 11,
        });
        opt.grid =  {
          x: isMoblie ? 10 : 7,
          y: 12,
          x2: isNightingale ? 6 : 7,
          y2: 0,
          containLabel: true,
        };
        if (type === 'percent' || formatRule?.toLowerCase().includes('percent')) {
          opt.yAxis.axisLabel.formatter = (value: number) => yAxisFormat(value, true, 2, true);
        }
        if (metrics_name === 'arpu') {
          opt.yAxis.axisLabel.formatter = (value) => {
            // 针对arpu特殊处理，因为值很小
            const formatLabel = value ? unitConversion(value, true) : value;
            const num = value < 1 && value > 0 ? formatSmallValue(value, 'decimals', 2) : formatLabel;
            return num;
          };
        }
        // 设计稿大小是11
        opt.xAxis = [{
          ...(opt.xAxis[0] || {}),
          boundaryGap: false,
          axisLabel: {
            ...(opt.xAxis[0]?.axisLabel || {}),
            fontSize: 11,
            color: '#BBBDCB',
            // align: "left"
          }
        }];
        opt.yAxis.axisLabel.fontSize = 11;
        opt.yAxis.axisLabel.color = '#BBBDCB';
        opt.tooltip.confine = false; // 浮窗不限制在图表区域
        opt.tooltip = {
          ...opt.tooltip,
          axisPointer: {
            ...opt.tooltip?.axisPointer,
            label: {
              ...opt.tooltip?.axisPointer?.label,
              padding: [5, 1, 0, 1],
              backgroundColor: 'transparent',
            }
          },
        };
        if (isPlatform) {
          opt.tooltip.position = function (point, params, dom, rect, size) {
            const obj = { top: 60 };
            obj[['left', 'right'][+(point[0] < size.viewSize[0] / 2)]] = 5;
            return obj;
          };
        }
        if ((index % 3 === 0 && !isPlatform) || shouldUseLeftCardTooltip) {
          opt.tooltip.position = function (point, params, dom, rect, size) {
            const obj: any = {
              top: point[1] - 120
            };
            const map: any = {
              right: point[0] + point[0] - size.viewSize[0] - 20,
              left: -20,
            };
            const pos = isNightingale ? 'left' : ['right', 'left'][+(point[0] < size.viewSize[0] / 2)];
            obj[pos] = isNightingale ? point[0] : point[0] - map[pos];
            return obj;
          };
        }
        return opt;
      }}
    />
  </div>;
};

export default MetricCardChartItem;